import { BaseResource } from 'utils/ApiUtils';

export default class Contact extends BaseResource {
  constructor(args) {
    super(args, Contact.attributes);
  };

  static columns = [
    { title: "First Name", field: "FirstName_Contact" },
    { title: "Last Name", field: "LastName_Contact" },
    { title: "Email", field: "Email_Contact" },
    { title: "Office Phone", field: "PhoneOffice_Contact" },
    { title: "Mobile Phone", field: "PhoneMobile_Contact" },
    { title: "Field Phone", field: "PhoneField_Contact" },
    { title: "Contractor", field: "Description_Contractor" },
    { title: "Contractor Id", field: "ContractorId_Contractor", hidden: true },
    { title: "Organization", field: "Name_Organization" },
    { title: "Organization Id", field: "OrganizationId_Organization", hidden: true },
    { title: "Active?", field: "IsActive_Contact", type: "boolean" },
    { title: "Title", field: "Title_Contact", hidden: true },
    { title: "ContactId", field: "ContactId_Contact", hidden: true },
    { title: "ProjectId", field: "ProjectId", hidden: true },
    { title: "CreatorSystemUserId", field: "CreatorSystemUserId_Contact", hidden: true },

  ]

  static attributes = Contact.columns.map(r => r.field);

  static expand = [
    {
      'Contact': {
        select: ['ContactId', 'FirstName', 'LastName', 'Email', 'PhoneOffice', 'PhoneMobile', 'PhoneField', 'Contractor', 'IsActive', 'Title', 'CreatorSystemUserId']
      }
    },
    {
      'Contact': {
        expand: [{ Organization: { select: ["Name", "OrganizationId"]}},  {Contractor: {select: ["Description", "ContractorId"]}}] 
      }
    }
  ];
};